import styles from './index.module.css';
import { LanguageContext } from '@/context/languageContext';
import { Spin } from 'antd';
import { useContext } from 'react';

export const NotFoundSearch = ({ isLoading }: { isLoading: boolean }) => {
  const { t } = useContext(LanguageContext);

  return (
    <div className={styles.wrapper}>
      {isLoading ? (
        <Spin />
      ) : (
        <>
          <img src="/assets/svg/listMagnifyingGlass.svg" alt="not found " />
          <div>{t('noMatches')}</div>
        </>
      )}
    </div>
  );
};
